/**
 * Permissão de notificações do navegador ("Ativar notificações" depois de instalar). O
 * envio dos avisos de escala pelo celular (Web Push) é do servidor e entra numa etapa
 * seguinte; aqui só se pede a permissão e se confirma com uma notificação local.
 */
export type NotificationStatus = 'unsupported' | 'default' | 'granted' | 'denied';

type Win = Window & Partial<Pick<typeof globalThis, 'Notification'>>;

export function notificationStatus(win: Win = window): NotificationStatus {
  if (!win.Notification) return 'unsupported';

  return win.Notification.permission;
}

export async function enableNotifications(win: Win = window): Promise<NotificationStatus> {
  if (!win.Notification) return 'unsupported';

  const permission = await win.Notification.requestPermission();

  if (permission === 'granted') await confirm(win);

  return permission;
}

const CONFIRMATION = {
  title: 'Notificações ativadas',
  body: 'Os avisos de escala do Live Gospel vão chegar por aqui.',
};

async function confirm(win: Win) {
  try {
    // No Android, só o service worker mostra notificação (o `new Notification` lança erro).
    const registration = await win.navigator.serviceWorker?.getRegistration();

    if (registration) await registration.showNotification(CONFIRMATION.title, { body: CONFIRMATION.body });
    else if (win.Notification) new win.Notification(CONFIRMATION.title, { body: CONFIRMATION.body });
  } catch {
    // A confirmação é cortesia: a permissão já foi dada.
  }
}
